export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10875.70b6d866.jpg";